<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.65155 0.890914C7.87975 0.829127 8.12027 0.829127 8.34847 0.890914C8.61339 0.962641 8.83642 1.13775 9.01442 1.2775C9.03142 1.29084 9.048 1.30386 9.06418 1.31644L13.5857 4.83319C13.6031 4.84673 13.6204 4.86013 13.6375 4.87342C13.8886 5.06828 14.1098 5.23995 14.2747 5.46282C14.4193 5.6584 14.5271 5.87874 14.5927 6.11301C14.6674 6.37996 14.6671 6.65996 14.6667 6.97779C14.6667 6.99948 14.6667 7.02134 14.6667 7.04338V11.8924C14.6667 12.2438 14.6667 12.547 14.6463 12.7967C14.6248 13.0602 14.5772 13.3224 14.4487 13.5746C14.2569 13.951 13.951 14.2569 13.5747 14.4487C13.3224 14.5772 13.0603 14.6248 12.7967 14.6463C12.547 14.6667 12.2438 14.6667 11.8924 14.6667H4.10763C3.75621 14.6667 3.45304 14.6667 3.20333 14.6463C2.93976 14.6248 2.67762 14.5772 2.42536 14.4487C2.04904 14.2569 1.74308 13.951 1.55133 13.5746C1.4228 13.3224 1.37526 13.0602 1.35372 12.7967C1.33332 12.547 1.33333 12.2438 1.33334 11.8924L1.33334 7.04338C1.33334 7.02133 1.33332 6.99947 1.3333 6.97779C1.33295 6.65996 1.33265 6.37996 1.40737 6.11301C1.47295 5.87874 1.58071 5.6584 1.72537 5.46282C1.89021 5.23995 2.11142 5.06828 2.36251 4.87342C2.37964 4.86013 2.39691 4.84673 2.41431 4.83319L6.93585 1.31644C6.95202 1.30386 6.9686 1.29084 6.9856 1.2775C7.1636 1.13775 7.38664 0.962641 7.65155 0.890914Z" :fill="color"/>
    </svg>
</template>

<script>
    export default {
        name: 'EnvelopIcon',
        props: {
            color: {
                type: String,
                default: '#000000',
                validator: function(value) {
                    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(value);
                }
            }
        },
        data() {
            return {
                
            }
        }
    }
</script>